<section class="main-outer__content-outer therapist-module-outer old-rt">
  <app-therapist-header></app-therapist-header>
  <div class="content-area">
    <div class="title-block">
      <div class="title-block__left">
        <h1>{{pageTitle}}</h1>
      </div>
      <div class="calendar-top-right" style="z-index:999 !important" *ngIf="!isGoogleMap">
        <span class="show-mobile-view"></span>
        <button class="btn btn--primary" (click)="myAvailability()">My Availability</button>
        <p-select class="select-box select-view-facility" [options]="calendarActions"
          [(ngModel)]="selectedcalendarActions" (onChange)="RedirectcalendarActions()"
          placeholder="Select Calendar View" optionLabel="name" appendTo="body"></p-select>
      </div>
      <div class="therapist-title-block__right-block" *ngIf="isGoogleMap">
        <button class="btn btn--secondary week-view" (click)="back()">
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.6111 1.40283L1 4.90109L4.6111 8.39935" stroke="#ffffff" stroke-width="1.6"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 4.90106L6.77777 4.90106C10.7666 4.90106 14 8.0334 14 11.8976V12.5972" stroke="#ffffff"
              stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          My Appointments
        </button>
        <button class="btn btn--primary ml-15" [routerLink]="['/therapist/my-availability']">My Availability
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.82975 1.73611L13.2258 5.02604L9.82975 8.31597" stroke="white" stroke-width="1.6"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.2258 5.02603L7.79211 5.02603C4.04083 5.02603 1 7.97183 1 11.6059V12.2639" stroke="white"
              stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

    <div class="calendra-top-btn old-rt-calendar-top-right">
      <div class="btn-group calendra-next-prev-btn">
        <div class="btn btn--arrow prev" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="dateOrViewChanged()" (click)="dateChange()">
          <i class="arrow-prev"></i>
        </div>

        <div class="btn btn--primary" mwlCalendarToday [(viewDate)]="viewDate" (viewDateChange)="dateOrViewChanged()">
          Today
        </div>

        <div class="btn btn--arrow next" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
          (viewDateChange)="dateOrViewChanged()" (click)="dateChange()">
          <i class="arrow-next"></i>
        </div>

        <div class="calendar-day">
          <p-calendar class="form__calendars therapist-select-date" dateFormat={{appDateFormat.primeFormat}}
            [(ngModel)]="viewDate" [locale]="en" [numberOfMonths]="1" [showIcon]="true" [readonlyInput]="true"
            (onSelect)="dateOrViewChanged()">
          </p-calendar>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <div class="loader-block">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
          animationDuration=".8s">
        </p-progressSpinner>
      </div>
    </ng-template>

    <div class="calendar-outer">
      <div class="admin-availability-calandar">
        <div class="admin-availabilty-calc">
          <div class="admin-availabilty-calc__left">
            <div class="therapist-availabilty-calc__left__block view-by-facility">
              <p-scrollPanel styleClass="therapist-module-calendar-scroll" [style]="{width: '100%', height: '100%'}">
                <div class="horizontal-scroll admin-appointments-week" [ngSwitch]="view">
                  <ng-template #customEventTemplate let-event="event">
                    <div class="custom-event" mwlCalendarTooltip="" [tooltipPlacement]="'top'">
                      <!--Appintment Box-->
                      <div class="calendar-box done"
                        *ngIf="event.event.id != 0 && event.event.id != -1 &&  !event.event.meta.eventObject.is15minSlot">
                        <span class="patient-color"></span>

                        <div class="calendar-box__title">
                          <h6
                            [pTooltip]="event.event.meta.eventObject.isGrouped ? getGroupPatientNames(event.event.meta.eventObject.groupAppointmentId) : event.event.title">

                            {{ event.event.title }}

                            <span
                              *ngIf="event.event.meta.eventObject.isGrouped && getGroupOptions(event.event.meta.eventObject.groupAppointmentId).length > 1"
                              pTooltip="{{getGroupPatientNames(event.event.meta.eventObject.groupAppointmentId)}}"
                              tooltipStyleClass="large-tooltip-outer">+{{getGroupOptions(event.event.meta.eventObject.groupAppointmentId).length
                              - 1}} More</span>

                            <span class="appointment-icon">
                              <!-- Group Appointment Icon -->
                              <svg *ngIf="event.event.meta.eventObject.isGrouped" width="17" height="15"
                                viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M9.35 8.82353C10.2517 8.82353 11.1165 9.19538 11.7542 9.85727C12.3918 10.5192 12.75 11.4169 12.75 12.3529V14.1176C12.75 14.3517 12.6604 14.5761 12.501 14.7416C12.3416 14.907 12.1254 15 11.9 15C11.6746 15 11.4584 14.907 11.299 14.7416C11.1396 14.5761 11.05 14.3517 11.05 14.1176V12.3529C11.05 11.8849 10.8709 11.4361 10.5521 11.1051C10.2333 10.7742 9.80087 10.5882 9.35 10.5882H3.4C2.94913 10.5882 2.51673 10.7742 2.19792 11.1051C1.87911 11.4361 1.7 11.8849 1.7 12.3529V14.1176C1.7 14.3517 1.61045 14.5761 1.45104 14.7416C1.29163 14.907 1.07543 15 0.85 15C0.624566 15 0.408365 14.907 0.248959 14.7416C0.0895533 14.5761 0 14.3517 0 14.1176V12.3529C0 11.4169 0.358213 10.5192 0.995837 9.85727C1.63346 9.19538 2.49826 8.82353 3.4 8.82353H9.35ZM14.45 8.82353C15.1263 8.82353 15.7749 9.10242 16.2531 9.59883C16.7313 10.0953 17 10.7685 17 11.4706V13.2353C17 13.4693 16.9104 13.6937 16.751 13.8592C16.5916 14.0247 16.3754 14.1176 16.15 14.1176C15.9246 14.1176 15.7084 14.0247 15.549 13.8592C15.3896 13.6937 15.3 13.4693 15.3 13.2353V11.4706C15.3 11.2366 15.2104 11.0121 15.051 10.8467C14.8916 10.6812 14.6754 10.5882 14.45 10.5882H13.2464C12.9524 9.88914 12.4888 9.28112 11.9009 8.82353H14.45ZM6.375 0C7.38945 0 8.36236 0.418329 9.07968 1.16296C9.79701 1.90759 10.2 2.91752 10.2 3.97059C10.2 5.02365 9.79701 6.03359 9.07968 6.77822C8.36236 7.52285 7.38945 7.94118 6.375 7.94118C5.36055 7.94118 4.38764 7.52285 3.67032 6.77822C2.95299 6.03359 2.55 5.02365 2.55 3.97059C2.55 2.91752 2.95299 1.90759 3.67032 1.16296C4.38764 0.418329 5.36055 0 6.375 0ZM13.6 2.64706C14.2763 2.64706 14.9249 2.92594 15.4031 3.42236C15.8813 3.91878 16.15 4.59207 16.15 5.29412C16.15 5.99616 15.8813 6.66945 15.4031 7.16587C14.9249 7.66229 14.2763 7.94118 13.6 7.94118C12.9237 7.94118 12.2751 7.66229 11.7969 7.16587C11.3187 6.66945 11.05 5.99616 11.05 5.29412C11.05 4.59207 11.3187 3.91878 11.7969 3.42236C12.2751 2.92594 12.9237 2.64706 13.6 2.64706ZM6.375 1.76471C5.81142 1.76471 5.27091 1.99711 4.8724 2.41079C4.47388 2.82448 4.25 3.38555 4.25 3.97059C4.25 4.55562 4.47388 5.1167 4.8724 5.53038C5.27091 5.94407 5.81142 6.17647 6.375 6.17647C6.93859 6.17647 7.47909 5.94407 7.8776 5.53038C8.27612 5.1167 8.5 4.55562 8.5 3.97059C8.5 3.38555 8.27612 2.82448 7.8776 2.41079C7.47909 1.99711 6.93859 1.76471 6.375 1.76471ZM13.6 4.41176C13.3746 4.41176 13.1584 4.50473 12.999 4.6702C12.8396 4.83567 12.75 5.0601 12.75 5.29412C12.75 5.52813 12.8396 5.75256 12.999 5.91804C13.1584 6.08351 13.3746 6.17647 13.6 6.17647C13.8254 6.17647 14.0416 6.08351 14.201 5.91804C14.3604 5.75256 14.45 5.52813 14.45 5.29412C14.45 5.0601 14.3604 4.83567 14.201 4.6702C14.0416 4.50473 13.8254 4.41176 13.6 4.41176Z"
                                  fill="#868686" />
                              </svg>
                              <!-- Individual Appointment Icon -->
                              <svg *ngIf="!event.event.meta.eventObject.isGrouped" width="14" height="15"
                                viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0ZM7 10C10.866 10 14 11.567 14 13.5V15H0V13.5C0 11.567 3.134 10 7 10Z"
                                  fill="#868686" />
                              </svg>
                            </span>
                          </h6>

                          <span class="time"
                            pTooltip="{{  event.event.meta.eventObject.startLabel | date:'shortTime' | lowercase}} - {{  event.event.meta.eventObject.endLabel | date:'shortTime'| lowercase }} | {{ event.event.meta.eventObject.facilityTimeZone }}">{{
                            event.event.meta.eventObject.startLabel | date:'shortTime' | lowercase}} - {{
                            event.event.meta.eventObject.endLabel | date:'shortTime'| lowercase }} | {{
                            event.event.meta.eventObject.facilityTimeZone }}</span>

                          <span class="soid">
                            SO# <a
                              (click)="onNavigateBrightTreeSalesOrderUrl(event.event.meta.eventObject?.appointment?.crmSalesorderAppId)"
                              href="javascript:void(0)">
                              {{event.event.meta.eventObject?.appointment?.crmSalesorderAppId}}
                            </a>
                          </span>

                          <span class="classification"
                            pTooltip="{{event.event.meta.eventObject.crmClassificationDisplayName}}">
                            {{event.event.meta.eventObject.crmClassificationDisplayName}}
                          </span>

                          <span class="classification" pTooltip="{{event.event.meta.eventObject.appointmentType}}">
                            {{event.event.meta.eventObject.appointmentType}}
                          </span>

                        </div>

                        <span class="valign-center edit-btn-block">
                          <a [attr.disabled]="!canChangeNoShowCompleteStatus"
                            (click)="editEvent(event.event.id,event.event.meta.eventObject.dateTimeLastModified)"
                            href="javascript:void(0)"> <i class="edit-icon-new"></i></a>

                          <a *ngIf="event.event.meta.eventObject.isGrouped" href="javascript:void(0)"
                            class="dot-icons dot-icons-status" (click)="openGroupMenu($event, event.event)">
                            <svg width="21" height="5" viewBox="0 0 21 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                              <circle cx="10.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                              <circle cx="18.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                            </svg>
                          </a>
                        </span>
                      </div>



                      <!--Half Box(15 min)-->
                      <div class="calendar-box done half-slot"
                        *ngIf="event.event.id != 0 && event.event.id != -1 && event.event.meta.eventObject.is15minSlot">
                        <span class="patient-color"></span>

                        <div class="calendar-box__title">
                          <h6
                            [pTooltip]="event.event.meta.eventObject.isGrouped ? getGroupPatientNames(event.event.meta.eventObject.groupAppointmentId) : event.event.title">
                            {{ event.event.title }}
                            <span
                              *ngIf="event.event.meta.eventObject.isGrouped && getGroupOptions(event.event.meta.eventObject.groupAppointmentId).length > 1"
                              pTooltip="{{getGroupPatientNames(event.event.meta.eventObject.groupAppointmentId)}}"
                              tooltipStyleClass="large-tooltip-outer">+{{getGroupOptions(event.event.meta.eventObject.groupAppointmentId).length
                              - 1}} More</span>

                            <span class="appointment-icon">
                              <!-- Group Appointment Icon -->
                              <svg *ngIf="event.event.meta.eventObject.isGrouped" width="17" height="15"
                                viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M9.35 8.82353C10.2517 8.82353 11.1165 9.19538 11.7542 9.85727C12.3918 10.5192 12.75 11.4169 12.75 12.3529V14.1176C12.75 14.3517 12.6604 14.5761 12.501 14.7416C12.3416 14.907 12.1254 15 11.9 15C11.6746 15 11.4584 14.907 11.299 14.7416C11.1396 14.5761 11.05 14.3517 11.05 14.1176V12.3529C11.05 11.8849 10.8709 11.4361 10.5521 11.1051C10.2333 10.7742 9.80087 10.5882 9.35 10.5882H3.4C2.94913 10.5882 2.51673 10.7742 2.19792 11.1051C1.87911 11.4361 1.7 11.8849 1.7 12.3529V14.1176C1.7 14.3517 1.61045 14.5761 1.45104 14.7416C1.29163 14.907 1.07543 15 0.85 15C0.624566 15 0.408365 14.907 0.248959 14.7416C0.0895533 14.5761 0 14.3517 0 14.1176V12.3529C0 11.4169 0.358213 10.5192 0.995837 9.85727C1.63346 9.19538 2.49826 8.82353 3.4 8.82353H9.35ZM14.45 8.82353C15.1263 8.82353 15.7749 9.10242 16.2531 9.59883C16.7313 10.0953 17 10.7685 17 11.4706V13.2353C17 13.4693 16.9104 13.6937 16.751 13.8592C16.5916 14.0247 16.3754 14.1176 16.15 14.1176C15.9246 14.1176 15.7084 14.0247 15.549 13.8592C15.3896 13.6937 15.3 13.4693 15.3 13.2353V11.4706C15.3 11.2366 15.2104 11.0121 15.051 10.8467C14.8916 10.6812 14.6754 10.5882 14.45 10.5882H13.2464C12.9524 9.88914 12.4888 9.28112 11.9009 8.82353H14.45ZM6.375 0C7.38945 0 8.36236 0.418329 9.07968 1.16296C9.79701 1.90759 10.2 2.91752 10.2 3.97059C10.2 5.02365 9.79701 6.03359 9.07968 6.77822C8.36236 7.52285 7.38945 7.94118 6.375 7.94118C5.36055 7.94118 4.38764 7.52285 3.67032 6.77822C2.95299 6.03359 2.55 5.02365 2.55 3.97059C2.55 2.91752 2.95299 1.90759 3.67032 1.16296C4.38764 0.418329 5.36055 0 6.375 0ZM13.6 2.64706C14.2763 2.64706 14.9249 2.92594 15.4031 3.42236C15.8813 3.91878 16.15 4.59207 16.15 5.29412C16.15 5.99616 15.8813 6.66945 15.4031 7.16587C14.9249 7.66229 14.2763 7.94118 13.6 7.94118C12.9237 7.94118 12.2751 7.66229 11.7969 7.16587C11.3187 6.66945 11.05 5.99616 11.05 5.29412C11.05 4.59207 11.3187 3.91878 11.7969 3.42236C12.2751 2.92594 12.9237 2.64706 13.6 2.64706ZM6.375 1.76471C5.81142 1.76471 5.27091 1.99711 4.8724 2.41079C4.47388 2.82448 4.25 3.38555 4.25 3.97059C4.25 4.55562 4.47388 5.1167 4.8724 5.53038C5.27091 5.94407 5.81142 6.17647 6.375 6.17647C6.93859 6.17647 7.47909 5.94407 7.8776 5.53038C8.27612 5.1167 8.5 4.55562 8.5 3.97059C8.5 3.38555 8.27612 2.82448 7.8776 2.41079C7.47909 1.99711 6.93859 1.76471 6.375 1.76471ZM13.6 4.41176C13.3746 4.41176 13.1584 4.50473 12.999 4.6702C12.8396 4.83567 12.75 5.0601 12.75 5.29412C12.75 5.52813 12.8396 5.75256 12.999 5.91804C13.1584 6.08351 13.3746 6.17647 13.6 6.17647C13.8254 6.17647 14.0416 6.08351 14.201 5.91804C14.3604 5.75256 14.45 5.52813 14.45 5.29412C14.45 5.0601 14.3604 4.83567 14.201 4.6702C14.0416 4.50473 13.8254 4.41176 13.6 4.41176Z"
                                  fill="#868686" />
                              </svg>
                              <!-- Individual Appointment Icon -->
                              <svg *ngIf="!event.event.meta.eventObject.isGrouped" width="14" height="15"
                                viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0ZM7 10C10.866 10 14 11.567 14 13.5V15H0V13.5C0 11.567 3.134 10 7 10Z"
                                  fill="#868686" />
                              </svg>
                            </span>
                          </h6>

                          <span class="time"
                            pTooltip="{{  event.event.meta.eventObject.startLabel | date:'shortTime' | lowercase}} - {{  event.event.meta.eventObject.endLabel | date:'shortTime'| lowercase }} | {{ event.event.meta.eventObject.facilityTimeZone }}">{{
                            event.event.meta.eventObject.startLabel | date:'shortTime' | lowercase}} - {{
                            event.event.meta.eventObject.endLabel | date:'shortTime'| lowercase }} | {{
                            event.event.meta.eventObject.facilityTimeZone }}</span>


                          <div class="soid">
                            SO# <a
                              (click)="onNavigateBrightTreeSalesOrderUrl(event.event.meta.eventObject?.appointment?.crmSalesorderAppId)"
                              href="javascript:void(0)">{{event.event.meta.eventObject?.appointment?.crmSalesorderAppId}}</a>
                          </div>
                        </div>

                        <span class="valign-center edit-btn-block">
                          <a (click)="editEvent(event.event.id,event.event.meta.eventObject.dateTimeLastModified)"
                            href="javascript:void(0)"> <i class="edit-icon-new"></i></a>

                          <a *ngIf="event.event.meta.eventObject.isGrouped" href="javascript:void(0)"
                            class="dot-icons dot-icons-status" (click)="openGroupMenu($event, event.event)">
                            <svg width="21" height="5" viewBox="0 0 21 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                              <circle cx="10.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                              <circle cx="18.5" cy="2.5" r="2.5" fill="#9E9E9E" />
                            </svg>
                          </a>
                        </span>
                      </div>

                      <!--Block Slot-->
                      <div class="calendar-box done isBlock" *ngIf="event.event.id == -1">
                        <span class="patient-color"></span>
                        <div class="calendar-box__title">
                          <h6 pTooltip="{{ event.event.title }}">{{ event.event.title }}</h6>

                          <span class="time"
                            pTooltip="{{ event.event.start | date:'shortTime' | lowercase}} - {{ event.event.end |  date:'shortTime' | lowercase }}">{{
                            event.event.start | date:'shortTime' | lowercase}} - {{ event.event.end | date:'shortTime' |
                            lowercase }}</span>

                        </div>
                      </div>

                      <!--Break Houur-->
                      <div class="calendar-box done break-hours" *ngIf="event.event.id == 0">
                        <span class="patient-color"></span>
                        <div class="calendar-box__title">
                          <h6 pTooltip="{{ event.event.title }}">{{ event.event.title }}</h6>

                          <span class="time"
                            pTooltip="{{ event.event.start | date:'shortTime' | lowercase}} - {{ event.event.end |  date:'shortTime' | lowercase }}">{{
                            event.event.start | date:'shortTime' | lowercase}} - {{ event.event.end | date:'shortTime' |
                            lowercase }}</span>

                        </div>

                      </div>

                    </div>
                  </ng-template>


                  <calendar-scheduler-view #calendarScheduler *ngSwitchCase="CalendarView.Week" [viewDays]="viewDays"
                    [viewDate]="viewDate" [events]="events" [locale]="locale" [responsive]="false"
                    [weekStartsOn]="weekStartsOn" [excludeDays]="excludeDays" [startsWithToday]="startsWithToday"
                    [hourSegments]="hourSegments" [hourSegmentHeight]="125" [dayStartHour]="dayStartHour"
                    [dayEndHour]="dayEndHour" [dayStartMinute]="dayStartMinute" [dayEndMinute]="dayEndMinute"
                    [dayModifier]="dayModifier" [hourModifier]="hourModifier" [segmentModifier]="segmentModifier"
                    [eventModifier]="eventModifier" [showEventActions]="true" [showSegmentHour]="false"
                    [zoomEventOnHover]="false" (viewDaysChanged)="viewDaysChanged($event)"
                    (dayHeaderClicked)="dayHeaderClicked($event.day)" (hourClicked)="hourClicked($event.hour)"
                    (segmentClicked)="segmentClicked('Clicked', $event.segment)"
                    (eventClicked)="eventClicked('Clicked', $event.event)"
                    (eventTimesChanged)="eventTimesChanged($event)" [eventTemplate]="customEventTemplate"
                    [refresh]="refresh">
                  </calendar-scheduler-view>
                </div>
              </p-scrollPanel>
            </div>
          </div>

          <p-dialog appendTo="body" class="fill-slot-popup" [(visible)]="twoFacilityPopup" [modal]="true"
            (onHide)="closePopup()" *ngIf="isShowModel">
            <div class="select-options-facility">
              <div class="therapist-module-popup-detils">
                <div class="therapist-module-popup-detils__title-block">
                  <h2 class="title">{{appointment?.salesOrderInfo?.patientInfo?.crmPatientLastName}},
                    {{appointment?.salesOrderInfo?.patientInfo?.crmPatientFirstName}} </h2>
                  <span class="date-of-birth">
                    <i class="birthdate-new"></i>
                    {{appointment?.salesOrderInfo?.patientInfo?.crmPatientBirthDate | date:appDateFormat.dateFormat}}
                  </span>
                </div>
                <div class="therapist-availabilty-calc__right__block">
                  <div class="therapist-availabilty__block">
                    <div class="therapist-availabilty__block__sales-order sales-order-border">
                      <span>
                        <strong>Sales Order ID</strong>
                        <a (click)="onNavigateBrightTreeSalesOrderUrl(appointment?.salesOrderInfo?.crmSalesorderAppId)"
                          href="javascript:void(0)">{{appointment?.salesOrderInfo?.crmSalesorderAppId}}</a>
                      </span>
                      <span>
                        <strong>Patient ID</strong>
                        <a (click)="onNavigateBrightTreePatientUrl(appointment.salesOrderInfo?.patientInfo?.crmRcmBrightreeID)"
                          href="javascript:void(0)">{{appointment?.salesOrderInfo?.crmPatientId}}</a>
                      </span>
                    </div>
                    <div class="therapist-availabilty__block__sales-order sales-order-border">
                      <ul class="therapist-availabilty__block__email-phone first">
                        <li>
                          <a href="mailto:{{appointment?.salesOrderInfo?.patientInfo?.crmPatientEmailAddress}}">
                            <i class="email-ic-new"></i>
                            {{appointment?.salesOrderInfo?.patientInfo?.crmPatientEmailAddress}}
                          </a>
                        </li>
                        <li>
                          <a href="tel:{{appointment?.salesOrderInfo?.patientInfo?.crmPatientMobileNumber}}">
                            <i class="phone-icon-new-primary"></i>
                            {{appointment?.salesOrderInfo?.patientInfo?.crmPatientMobileNumber }}
                          </a>
                        </li>
                        <li>
                          <a href="tel:{{appointment?.salesOrderInfo?.patientInfo?.crmPatientPhoneNo}}">
                            <i class="voice-call-icon-new-primary"></i>
                            {{appointment?.salesOrderInfo?.patientInfo?.crmPatientPhoneNo }}
                          </a>
                        </li>
                      </ul>
                      <ul
                        *ngIf="appointment?.salesOrderInfo?.crmSalesorderOrderNote || appointment?.salesOrderInfo?.crmSalesorderDeliveryNote"
                        class="therapist-availabilty__block__email-phone">
                        <li>
                          <a *ngIf="appointment?.salesOrderInfo?.crmSalesorderOrderNote" class="link"
                            href="javascript:void(0)"
                            pTooltip="{{appointment?.salesOrderInfo?.crmSalesorderOrderNote}}">
                            Order Note
                          </a>
                        </li>
                        <li>
                          <a *ngIf="appointment?.salesOrderInfo?.crmSalesorderDeliveryNote" class="link"
                            href="javascript:void(0)"
                            pTooltip="{{appointment?.salesOrderInfo?.crmSalesorderDeliveryNote}}">
                            Delivery Note
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="therapist-availabilty__block__sales-order sales-order-border">
                      <span>
                        <strong>Status</strong>
                        <div class="therapist-calendar-status therapist-calendar-status--selectbox"
                          *ngIf="isShowStatusDropdown">
                          <select class="form__select" (change)="changeWipStatus($event)">
                            <option value="0" selected>Select</option>
                            <option *ngFor="let summary of salesOrderStatusCurrent" value={{summary.wipStatesName}}>
                              {{summary.wipStatesName}}
                            </option>
                          </select>
                        </div>
                        <span *ngIf="!isShowStatusDropdown">
                          {{wipStatus}}
                        </span>
                      </span>

                      <span *ngIf="bDisaplyCancelVoidReason">
                        <strong>Reason</strong>
                        <div class="form__group full-width">
                          <p-select class="form__dropdown" [options]="reasonsResponseModel" [(ngModel)]="reason"
                            placeholder="Select Reason" optionLabel="salesOrderVoidReason" filter="true"></p-select>
                        </div>
                      </span>

                      <span>
                        <strong>Note</strong>
                        <div class="therapist-calendar-status">
                          <textarea [(ngModel)]="comments" class="form__textarea" pInputTextarea
                            maxlength="500"></textarea>
                        </div>
                      </span>
                      <span>
                        <strong></strong>
                        <div style="margin-bottom: 1rem !important;" class="therapist-calendar-status"
                          *ngIf="isShowStatusDropdown">
                          <span class="form__checkbox-outer" style="display: flex;">
                            <p-checkbox name="groupnamecomplete"
                              label="If box checked, the WIP State will not be updated in Brightree"
                              inputId="groupnamecomplete" [(ngModel)]="isBrightreeSystemAppUpdate" binary="true"
                              (onChange)="onBTSelect($event)" [ngModelOptions]="{standalone: true}">

                            </p-checkbox>
                            <label class="form__checkbox-label" for="groupnamecomplete">
                              If box checked, the WIP State will not be updated in Brightree
                            </label>
                          </span>
                        </div>

                      </span>

                      <span style="margin-bottom: 1rem !important;">
                        <strong></strong>
                        <div class="add-note-btn"><a href="javascript:void(0)" class="btn btn--primary"
                            (click)="UpdateStatusWithNote(appointment?.schAppointmentId,appointment?.appointmentDetailInfo?.crmFacilityId)">Update</a>
                        </div>
                      </span>
                    </div>
                  </div>
                  <p-accordion class="accordion view-by-therapist" #accordion>
                    <p-accordionTab header="Appointment Information" [selected]="true">
                      <div class="therapist-availabilty__block">
                        <div class="therapist-availabilty__block__sales-order">
                          <span><strong>Date</strong>{{appointment?.schAppointmentDateStartTime |
                            date:appDateFormat.dateFormat }}</span>
                          <!--<span><strong>Time</strong> {{appointment?.appointmentDetailInfo?.schAppointmentDateStartTime | date:'shortTime' | lowercase}} to {{appointment?.appointmentDetailInfo?.schAppointmentDateEndTime | date:'shortTime' | lowercase}} | {{_patientTimezone}}</span>-->
                          <span>
                            <strong>Time</strong> {{appointment?.schAppointmentDateStartTime | date:'shortTime'
                            |lowercase }} to
                            {{appointment?.schAppointmentDateEndTime | date:'shortTime' |lowercase }} |
                            {{_patientTimezone}}
                          </span>
                          <span>
                            <strong>Duration</strong> <small class="hour">
                              {{duration}} <i class="info-new"
                                pTooltip="{{appointment?.salesOrderInfo?.crmClassificationDescription}}"></i>
                            </small>
                          </span>
                          <span>
                            <strong *ngIf="appointment.schAppointmentType=='Facility Visit'">Facility</strong>
                            {{appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityName}}
                          </span>
                          <span>
                            <strong *ngIf="appointment.schAppointmentType=='Home Visit'">Home Address</strong>
                            <span *ngIf="appointment.schAppointmentType=='Home Visit'">
                              <span *ngIf="appointment.schIsBillingAddress">
                                {{appointment?.salesOrderInfo?.patientInfo?.crmPatientAddress}}
                              </span>
                              <span *ngIf="appointment.schIsBillingAddress==false">
                                {{appointment?.salesOrderInfo?.crmPatientDeliveryAddress}}
                              </span>
                            </span>
                            <strong *ngIf="appointment.schAppointmentType=='Facility Visit'">Facility Address</strong>
                            <span *ngIf="appointment.schAppointmentType=='Facility Visit'">
                              <span>{{appointment?.appointmentDetailInfo?.facilityInfo?.crmAddressLine1}}</span>
                              <span
                                *ngIf="appointment?.appointmentDetailInfo?.facilityInfo?.crmAddressLine2">{{appointment?.appointmentDetailInfo?.facilityInfo?.crmAddressLine2}}</span>
                              <span>{{appointment?.appointmentDetailInfo?.facilityInfo?.crmCity}}</span>
                              <span>{{appointment?.appointmentDetailInfo?.facilityInfo?.crmState}}</span>
                              <span>{{appointment?.appointmentDetailInfo?.facilityInfo?.crmFacilityZipCode}}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab *ngIf="appointment?.salesOrderInfo?.doctorInfo" header="Doctor Information">
                      <div class="therapist-availabilty__block">
                        <h3 class="scheduled-detials__left__block__title">
                          {{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorFirstName}}
                          {{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorLastName}}</h3>

                        <!-- <h5 class="scheduled-detials__left__block__title">{{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorAddress}}</h5> -->
                        <ul class="therapist-availabilty__block__email-phone"
                          *ngIf="appointment?.salesOrderInfo?.doctorInfo?.crmDoctorAddress">
                          <li class="location-block">
                            <a href="javascript:void(0);" style="cursor: default; pointer-events: none;">
                              <i class="location-icon"></i>
                              {{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorAddress}}
                            </a>
                          </li>
                        </ul>
                        <ul
                          *ngIf="appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactEmailAddress || appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactNo"
                          class="therapist-availabilty__block__email-phone mb-0">
                          <li *ngIf="appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactEmailAddress">
                            <a href="mailto:{{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactEmailAddress}}">
                              <i class="email-ic-new"></i>
                              {{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactEmailAddress}}
                            </a>
                          </li>
                          <li *ngIf="appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactNo">
                            <a href="tel:{{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactNo}}">
                              <i class="voice-call-icon-new-primary"></i>
                              {{appointment?.salesOrderInfo?.doctorInfo?.crmDoctorContactNo}}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="Device Information">
                      <div class="therapist-availabilty__block">
                        <div class="therapist-availabilty__block__sales-order">
                          <span><strong>Classification</strong>{{appointment?.salesOrderInfo?.crmSalesorderClassification}}</span>
                          <span><strong>Due Amount</strong> ${{appointment?.salesOrderInfo?.amountDue}}</span>
                          <span
                            *ngIf="appointment?.salesOrderInfo?.salesOrderInsuranceInfo[0]?.crmPolicyHolderName"><strong>Insurance</strong>
                            {{ appointment?.salesOrderInfo?.salesOrderInsuranceInfo[0]?.crmPolicyHolderName}}</span>
                          <span
                            *ngIf="!appointment?.salesOrderInfo?.salesOrderInsuranceInfo[0]?.crmPolicyHolderName"><strong>Insurance</strong>-</span>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="Insurance &amp; Policy Information">
                      <div class="therapist-availabilty__block therapist-availabilty__block--insurance">
                        <p-tabView class="appointment-detail">
                          <p-tabPanel [header]="item.crmPayorLevel"
                            *ngFor="let item of appointment.salesOrderInfo.salesOrderInsuranceInfo; let i = index"
                            [selected]="i == 0">
                            <div class="insurance-info">
                              <div class="insurance-info__block mb-0">
                                <span *ngIf="item.crmInsurancePolicyNumber"><strong>Policy No.</strong>
                                  {{item.crmInsurancePolicyNumber}}</span>
                                <span *ngIf="!item.crmInsurancePolicyNumber"><strong>Policy No.</strong>-</span>
                                <span *ngIf="item.crmPolicyHolderName">
                                  <strong>Company</strong>{{item.crmPolicyHolderName}}
                                </span>
                                <span *ngIf="!item.crmPolicyHolderName">
                                  <strong>Company</strong>-
                                </span>
                                <span *ngIf="item.crmInsurancePolicyEffectiveDate"><strong>Effective Date</strong>
                                  {{item.crmInsurancePolicyEffectiveDate | date:appDateFormat.dateFormat}}</span>
                                <span *ngIf="!item.crmInsurancePolicyEffectiveDate"><strong>Effective
                                    Date</strong>-</span>
                                <span><strong>Insurance Verified</strong>{{item.crmInsuranceVerified ? 'Yes' : 'No'}}
                                </span>
                                <span><strong>Coverage Verified</strong> {{item.crmCoverageVerified ? 'Yes' : 'No'}}
                                </span>
                              </div>
                            </div>
                          </p-tabPanel>
                        </p-tabView>
                      </div>
                    </p-accordionTab>
                  </p-accordion>
                </div>
              </div>
            </div>
          </p-dialog>


        </div>
      </div>
      <div class="loader-block" *ngIf="Customloading">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
          animationDuration=".8s">
        </p-progressSpinner>
      </div>
    </div>
  </div>
  <div class="landscape-msg">
    <p>Application does not support landscape mode</p>
  </div>
</section>
<p-toast position="bottom-right"></p-toast>
<p-popover #groupPopover class="table-action-popup appointment-Action">
  <ul class="quick-link-menu status-popup">
    <li>
      <a href="javascript:void(0)" (click)="openPatientSidebar(selectedGroupEvent); groupPopover.hide()">
        Patient Status Update
      </a>
    </li>
    <li>
      <a href="javascript:void(0)" (click)="openAppointmentStatusUpdate(selectedGroupEvent); groupPopover.hide()">
        Bulk Status Update
      </a>
    </li>
  </ul>
</p-popover>
<!-- Appointment Detail Sidebar -->
<p-sidebar [(visible)]="patientDetailSidebar" [transitionOptions]="'300ms'"
  styleClass="patient-detail-sidebar z-index-999999" dismissible="false" position="right" appendTo="body"
  maskStyle="z-index: 999999 !important">
  <app-patient-detail-sidebar *ngIf="patientDetailSidebar" [patientDetail]="patientHeaderDetail"
    (wipsStatusCreated)="onSidebarStatusUpdate($event)" [salesOrderid]="salesOrder" [groupOptions]="sidebarGroupOptions"
    (groupPatientSelected)="onSidebarGroupPatientChange($event)"></app-patient-detail-sidebar>
</p-sidebar>

<p-dialog [(visible)]="AppointmentStatusUpdate" appendTo="body" [modal]="true" class="patient-popup"
  maskStyleClass="update-appointment-status" [baseZIndex]="10000">
  <div class="form-content-outer__content update-appointment-information">
    <h2>Bulk Update for All Patients</h2>
    <div class="appointment-type">
      <div class="appointment-type__left">
        <h3 class="appointment-type__title">{{getBulkGroupTitle()}} <span
            class="patient-count">({{getBulkGroupPatientCount()}} Patients)</span></h3>
        <span class="appointment-type__date-time">{{getBulkGroupStartTime() | date:'MM/dd/yyyy, hh:mm a' | lowercase}} -
          {{getBulkGroupEndTime() | date:'hh:mm a' | lowercase}} | {{getBulkGroupTimeZone()}}</span>
      </div>

      <div class="appointment-type__right">
        <span class="appointment-type__visit-type">{{getBulkGroupVisitType()}}</span>
        <span class="appointment-type__time-box">{{getBulkGroupDuration()}}</span>
      </div>

    </div>
    <div class="form">
      <div class="form__group">
        <label class="form__label">Appointment Status</label>
        <p-select class="form__dropdown" [options]="wipStatusModel" placeholder="Select" optionLabel="wipStatesName"
          [(ngModel)]="schWIPStatus" id="statusDropdown" filter="true" (onChange)="changeWipStatus($event)">
        </p-select>
      </div>
      <div class="form__group {{displayStatus}}" *ngIf="isStatusUpdated">
        {{displayStatus}}
      </div>
      <div class="form__group full-width" *ngIf="bDisaplyCancelVoidReason">
        <label class="form__label">Reason</label>
        <p-select class="form__dropdown" [options]="reasonsResponseModel" [(ngModel)]="reason"
          placeholder="Select Reason" optionLabel="salesOrderVoidReason" filter="true"></p-select>
      </div>
      <div class="form__group">
        <label class="form__label">Appointment Note</label>
        <textarea class="form__textarea" id="w3review" name="w3review" rows="4" cols="50"
          [(ngModel)]="appointmentNote"></textarea>
      </div>
      <div style="margin-bottom: 2rem !important;" class="therapist-calendar-status" *ngIf="!isStatusUpdated">
        <span class="form__checkbox-outer">
          <p-checkbox name="groupnamecomplete" label="If box checked, the WIP State will not be updated in Brightree"
            [(ngModel)]="isBrightreeSystemAppUpdate" binary="true" (onChange)="onBTSelect($event)"
            [ngModelOptions]="{standalone: true}" inputId="wipStateWillNotUpdate">
          </p-checkbox>
          <label class="form__checkbox-label" for="wipStateWillNotUpdate">If box checked, the WIP State will not be
            updated in Brightree</label>
        </span>
      </div>
      <div class="form__buttons">
        <button class="btn btn--primary" (click)="onUpdateAppointment()">Update</button>
      </div>
    </div>
  </div>
</p-dialog>